/**
 * Klarna on-site messaging — rounded corners.
 *
 * The <klarna-placement> widget renders its card inside an OPEN shadow root: a plain <div> with a
 * 1px border, a white background and border-radius: 0. We can't reach it from a theme stylesheet,
 * and clipping the host (border-radius + overflow: hidden) is worse — it slices the card's square
 * corners and leaves a notched edge. Instead, walk into the open shadow root and round the bordered
 * card itself.
 *
 * Klarna hydrates asynchronously, so poll until every placement on the page has a shadow root, and
 * re-apply on later re-renders (e.g. the price changes when a variant is picked).
 */
(function () {
  var RADIUS = '12px';
  var POLL_MS = 250;
  var MAX_TRIES = 40; // ~10s

  function roundCard(placement) {
    var root = placement.shadowRoot;
    if (!root) return false;

    var cards = root.querySelectorAll('div');
    var rounded = false;

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      // The card is the only node Klarna gives a visible border — round that one, and leave the
      // inner layout divs (and the Klarna badge) alone.
      if (parseFloat(getComputedStyle(card).borderTopWidth) > 0) {
        card.style.setProperty('border-radius', RADIUS, 'important');
        rounded = true;
      }
    }

    return rounded;
  }

  function apply() {
    var placements = document.querySelectorAll('klarna-placement');
    if (!placements.length) return false;

    var done = true;
    for (var i = 0; i < placements.length; i++) {
      if (!roundCard(placements[i])) done = false;
    }
    return done;
  }

  var tries = 0;
  var timer = setInterval(function () {
    if (apply() || ++tries >= MAX_TRIES) clearInterval(timer);
  }, POLL_MS);

  document.addEventListener('DOMContentLoaded', apply);
})();
